<!-- <app-header-one [sticky]="true" [Livelogo]="logoLive[0]?.imgurl"></app-header-one> -->

<app-breadcrumb class="hidevalue" [title]="'Collection'" [breadcrumb]="'Collection'"></app-breadcrumb>


<!-- section start -->
<section class="section-b-space hidepad">
    <div class="collection-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-3" id="mobilesidebar">
                    <div class="collection-filter" [class.openFilterbar]="mobileSidebar">
                        <!-- side-bar colleps block stat -->
                        <div class="collection-filter-block">
                            <div class="collection-mobile-back" (click)="toggleMobileSidebar()">
                                <span class="filter-back">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i> back
                                </span>
                            </div>
                            <!-- Category filter start -->
                            <app-categories></app-categories>
                        </div>

                        <!-- <div class="collection-filter-block" id="mobileupdatefilter">
                            <app-price [minDummy]="min1" [maxDummy]="max1" [min]="minPrice" [max]="maxPrice"
                                (priceFilter)="updateFilter($event)">
                            </app-price>
                        </div> -->

                        <div class="collection-filter-block mobileviewprod" id="mobilegrid">
                            <app-grid [filterecomdata]="ecomproducts" [paginate]="paginate" [sortBy]="sortBy"
                                class="mobileviewprod" (setGrid)="updateGridLayout($event)" [layoutView]="layoutView"
                                (setLayout)="updateLayoutView($event)" (sortedBy)="sortByFilter($event)">
                            </app-grid>
                        </div>

                        <div class="collection-filter-block mobileviewprod" id="view">
                            <div class="collection-collapse-block border-0" [class.open]="collapse">
                                <h3 class="collapse-block-title" (click)="collapse = !collapse">Views</h3>
                                <div class="collection-collapse-block-content">
                                    <div class="collection-brand-filter row">
                                        <div class="col-6 row" id="mobilegrid">
                                            <span [ngClass]="{'custom-color':griddoubleviews == true }"
                                                (click)="Grid2view()"><i class="fa fa-th-large"
                                                    aria-hidden="true"></i><span style="margin-left: 10px;">Grid
                                                    View</span></span>
                                        </div>
                                        <div class="col-6 row" id="mobilelistview">
                                            <span [ngClass]="{'custom-color':gridlistviews == true }"
                                                (click)="Listview()"><i class="fa fa-list" aria-hidden="true"></i><span
                                                    style="margin-left: 10px;">List View</span></span>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- silde-bar colleps block end here -->
                        <!-- side-bar colleps block stat -->

                        <!-- silde-bar colleps block end here -->
                        <!-- side-bar single product slider start -->


                        <!-- InCase of Future Update this Vertical New Products

                        <app-product-box-vertical-slider [title]="'New Products'">
                        </app-product-box-vertical-slider> -->


                        <!-- side-bar single product slider end -->
                        <!-- side-bar banner start here -->
                         

                        <div class="collection-sidebar-banner hidevalue" *ngIf="AdvImg">
                            <a href="javascript:void()" [routerLink]="['/shop/product/left/sidebar/', ad.productId, ad.name]">
                                <img [src]="AdvImg" class="img-fluid" alt="banner">
                            </a>
                        </div>


                        <!-- side-bar banner end here -->
                    </div>
                </div>
                <div class="collection-content col">
                    <div class="page-main-content">
                        <div class="row">
                            <div class="col-sm-12">
                                <!-- <div class="top-banner-wrapper">
                                    <a [routerLink]="['/shop/collection/left/sidebar']">
                                        <img src="assets/images/collection-banner.jpg" class="img-fluid " alt="">
                                    </a>
                                    <div class="top-banner-content small-section">
                                        <h4>fashion</h4>
                                        <h5>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        </h5>
                                        <p>
                                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has
                                            survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                            and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                        </p>
                                    </div>
                                </div> -->
                                <div class="row" id="mobilefilter">
                                    <div class="col-xl-12">
                                        <div class="filter-main-btn">
                                            <span class="filter-btn btn btn-theme" (click)="toggleMobileSidebar()">
                                                <i class="fa fa-filter" aria-hidden="true"></i> Filter
                                            </span>
                                        </div>


                                    </div>
                                </div>
                                <ul class="product-filter-tags">
                                    <li class="me-1" *ngFor="let tag of tags">
                                        <a href="javascript:void(0)" class="filter_tag">
                                            {{tag}} <i class="ti-close" (click)="removeTag(tag)"></i>
                                        </a>
                                    </li>
                                    <li class="clear_filter" *ngIf="tags.length > 0 ">
                                        <a href="javascript:void(0)" class="clear_filter" (click)="removeAllTags()">
                                            Clear all
                                        </a>
                                    </li>
                                </ul>
                                <div class="collection-product-wrapper" id="ecomproducts">
                                    <app-grid [filterecomdata]="ecomproducts" [paginate]="paginate" [sortBy]="sortBy"
                                        class="hidevalue" (setGrid)="updateGridLayout($event)" [layoutView]="layoutView"
                                        (setLayout)="updateLayoutView($event)" (sortedBy)="sortByFilter($event)">
                                    </app-grid>

                                    <!-- <div style="width: 12%;      padding: 0;
                                    " *ngIf="catId != 0">
                                        <button type="submit" id="clearsort-btn" aria-label="clearsort Data"
                                            class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;border-radius: 12px;
                                    color: black;" (click)="clearCategory()">
                                            <span style="text-transform: none;">Clear Category</span> <span
                                                style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                    class="fa fa-times" aria-hidden="true"></i></span>
                                        </button>
                                                  
                                    </div> -->

                                    <!-- {{maxPrice}}--{{minPrice}} -->
                                    <div class="row hidevalue gap-3" style="margin-left: 0px;margin-top: 10px;">

                                        <div *ngIf="catId != 0" style="width: 13%;      padding: 0;
                                            ">
                                            <button type="submit" id="clearpri-btn" aria-label="clearpri Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;border-radius: 12px;
                                        color: black;" (click)="clearCategory()">
                                                <span style="text-transform: none;">Clear Category </span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>



                                        <div *ngIf="maxPrice < 2000 || minPrice > 0" style="width: 13%;      padding: 0;
                                            ">
                                            <button type="submit" id="clearpri-btn" aria-label="clearpri Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;border-radius: 12px;
                                        color: black;" (click)="clear()">
                                                <span style="text-transform: none;">Clear Price </span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>
                                        <div *ngIf="grid != 'col-lg-3'" style="width: 12%;      padding: 0;
                                        ">
                                            <button type="submit" id="cleargrid-btn" aria-label="cleargrid Data"
                                                class="btn mt-2 text-nowrap " style="border-color: #ff4c3b;  border-radius: 12px;
                                            
                                        color: black;" (click)="clearGrid()">
                                                <span style="text-transform: none;">Clear Grid </span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>

                                        <div *ngIf="filterval != 'ascending'" style="width: 12%;      padding: 0;
                                        ">
                                            <button type="submit" id="clearsort-btn" aria-label="clearsort Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;border-radius: 12px;
                                        color: black;" (click)="clearsort()">
                                                <span style="text-transform: none;">Clear Sort</span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>

                                        <!-- {{grid}}---- {{filterval}}---- {{maxPrice}}----{{minPrice}} -->
                                        <div *ngIf=" (grid != 'col-lg-3' && ((maxPrice < 2000 || minPrice > 0) ||  filterval != 'ascending')) || 
                                            ( filterval != 'ascending' && ((maxPrice < 2000 || minPrice > 0) || grid != 'col-lg-3' )) "
                                            style="width: 12%;padding: 0;">
                                            <button type="submit" id="clearall-btn" aria-label="clearall Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;border-radius: 12px;
                                        color: black;" (click)="ClearAll()">
                                                <span style="text-transform: none;">Clear All</span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>

                                    </div>

                                    <div class="row mobileviewprod" id="clearbutton"
                                        style="margin-left: 0px;margin-top: 10px;">

                                        <div *ngIf="catId != 0" style="    max-width: fit-content; padding: 0;">
                                            <button type="submit" id="cleargrid-btn" aria-label="cleargrid Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;  border-radius: 12px;
                                            
                                        color: black;" (click)="clearCategory()">
                                                <span style="text-transform: none;">Clear Category </span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>


                                        <div *ngIf="maxPrice < 2000 || minPrice > 0" style="    max-width: fit-content; padding: 0;
                                            ">
                                            <button type="submit" id="clearpri-btn" aria-label="clearpri Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;border-radius: 12px;
                                        color: black;" (click)="clear()">
                                                <span style="text-transform: none;">Clear Price </span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>
                                        <div *ngIf="grid != 'col-lg-3'" style="    max-width: fit-content; padding: 0;
                                        ">
                                            <button type="submit" id="cleargrid-btn" aria-label="cleargrid Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;  border-radius: 12px;
                                            
                                        color: black;" (click)="clearGrid()">
                                                <span style="text-transform: none;">Clear Grid </span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>

                                        <div *ngIf="filterval != 'ascending'" style="    max-width: fit-content; padding: 0;
                                        ">
                                            <button type="submit" id="sortclear-btn" aria-label="sortclear Data"
                                                class="btn mt-2 text-nowrap" style="border-color: #ff4c3b;border-radius: 12px;
                                        color: black;" (click)="clearsort()">
                                                <span style="text-transform: none;">Clear Sort</span> <span
                                                    style="color: gray;margin-left: 7px;" class="ml-2"><i
                                                        class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </div>
                                    </div>


                                    <div class="product-wrapper-grid hidevalue" [ngClass]="layoutView" id="productbox">
                                        <div class="row">
                                            <div class="col-grid-box" [ngClass]="grid"
                                                *ngFor="let product of ecomproducts">
                                                <div class="product-box">
                                                    <app-product-box-one [ecomproduct]="product" [grids]="gridcol"
                                                        [currency]="productService?.Currency" [thumbnail]="false"
                                                        [cartModal]="true" [loader]="true">
                                                    </app-product-box-one>
                                                </div>
                                            </div>

                                            <div class="row  p-0 hidevalue" style="    margin-top: 50px;"
                                                *ngIf="grid == 'col-lg-6' &&  ecomproducts.length == 0 && load == false">
                                                <div class="col-6" style="padding-right: 0;padding-left: 20px;">
                                                    <div class="img-wrapper" style="margin-left: 4px;">
                                                        <div class="wrapperload6">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>

                                                <div class="col-6" style="padding-right: 0;padding-left: 23px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload6">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row p-0 hidevalue" style="    margin-top: 50px;" id="col4loader"
                                                *ngIf="grid == 'col-lg-4' &&  ecomproducts.length == 0 && load == false">
                                                <div class="col-4" style="padding-right: 0;padding-left: 20px;">
                                                    <div class="img-wrapper" style="margin-left: 4px;">
                                                        <div class="wrapperload9">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-4" style="padding-right: 0;padding-left: 23px;"
                                                    id="col4loader">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload9">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-4" style="padding-right: 0;padding-left: 23px;"
                                                    id="col4loader">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload9">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <h1>{{load}}</h1> -->
                                            <div class="row mt-5 p-0 hidevalue" style="margin-top: 50px;"
                                                id="col3loader"
                                                *ngIf="grid == 'col-lg-3' && ecomproducts.length == 0 && load == false"
                                                id="col3loader">
                                                <div class="col-3" style="padding-right: 0;padding-left: 25px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-3" style="padding-right: 0;padding-left: 20px;"
                                                    id="col3loader">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-3" style="padding-right: 0;padding-left: 23px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-3" style="padding-right: 0;padding-left: 23px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="row mt-5 p-0 hidevalue" style="margin-top: 50px;"
                                                id="col2loader"
                                                *ngIf="grid == 'col-lg-2' &&  ecomproducts.length == 0 && load == false">
                                                <div class="col-2" style="padding-right: 0;padding-left: 25px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload" style="    height: 200px;">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-2" style="padding-right: 0;padding-left: 20px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload" style="    height: 200px;">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-2" style="padding-right: 0;padding-left: 23px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload" style="    height: 200px;">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-2" style="padding-right: 0;padding-left: 23px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload" style="    height: 200px;">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-2" style="padding-right: 0;padding-left: 23px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload" style="    height: 200px;">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="col-2" style="padding-right: 0;padding-left: 23px;">
                                                    <div class="img-wrapper">
                                                        <div class="wrapperload" style="height: 200px;">
                                                            <div class="loaderzig">
                                                                <div class="loader__part loader__part--1"></div>
                                                                <div class="loader__part loader__part--2"></div>
                                                                <div class="loader__part loader__part--3"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="product-detail">
                                                        <h4 style="margin-top: 6px;">
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '130px', 'border-radius': '15px',  height: '15px', 'margin-bottom': '6px'}">
                                                            </ngx-skeleton-loader>
                                                        </h4>
                                                        <h5>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '160px', 'border-radius': '15px',  height: '12px'}">
                                                            </ngx-skeleton-loader>
                                                        </h5>
                                                        <h6>
                                                            <ngx-skeleton-loader
                                                                [theme]="{ 'background-color': '#e8e8e8', width: '70px', 'border-radius': '15px',  height: '14px'}">
                                                            </ngx-skeleton-loader>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-12 text-center section-b-space mt-5 no-found"
                                                *ngIf="ecomproducts.length == 0 && load == true">
                                                <img src="assets/images/empty-search.jpg" class="img-fluid mb-4">
                                                <h3>Sorry! Couldn't find the product you were looking For!!! </h3>
                                                <p>Please check if you have misspelt something or try searching with
                                                    other words.</p>
                                                <a [routerLink]="['/shop/collection/left/sidebar?category=118']"
                                                    class="btn btn-solid">continue shopping</a>
                                            </div>

                                        </div>



                                    </div>



                                    <div class="mobileviewprod" id="addwhishlist">
                                        <div class="row" *ngIf="griddoubleviews == true">


                                            <div class="col-6" *ngFor="let product of ecomproducts"
                                                style="padding: 10px;">
                                                <div class="img-wrapper">
                                                    <div class="cart-info cart-wrap">

                                                        <a href="javascript:void(0)" title="Add to Wishlist"
                                                            (click)="saveFav(product)">
                                                            <i class="fa fa-heart" aria-hidden="true"
                                                                [ngStyle]="product.fav ?{'color': 'red'} : {'color': 'white'}"></i>
                                                        </a>
                                                    </div>
                                                    <div class="lable-block">
                                                    </div>
                                                    <div class="front">
                                                        <a
                                                            [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
                                                            <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                                                                [lazyLoad]="ImageSrc ? ImageSrc : product?.img"
                                                                class="img-fluid lazy-loading"
                                                                alt="{{ product?.img }}" />

                                                        </a>
                                                    </div>
                                                    <div class="back" *ngIf="onHowerChangeImage">
                                                        <a
                                                            [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
                                                            <img [src]="ImageSrc ? ImageSrc : product.img"
                                                                class="img-fluid lazy-loading" alt="{{ product?.img }}">
                                                        </a>
                                                    </div>


                                                </div>
                                                <div class="product-detail">
                                                    <div>
                                                        <bar-rating *ngIf="product.avg_star > 0"
                                                            [rate]="product.avg_star" [readOnly]="true"></bar-rating>
                                                        <a
                                                            [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
                                                            <h6>{{ product?.pname | titlecase }}</h6>
                                                        </a>

                                                        <!-- <h4>
                                                            <strong class="kg" *ngIf="product?.cid > 0">1.5 KG
                                                                -</strong> ₹ {{ product?.pri}}
                                                        </h4> -->

                                                        <h4 style="padding-bottom: 10px;font-size: larger;"
                                                            *ngFor="let data of product.preDef">
                                                            <strong class="kg" *ngIf="product?.cid > 0">{{data.qty}}
                                                                -</strong> ₹ {{ data?.price}}
                                                        </h4>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="gridlistviews == true">

                                            <div class="col-12 row" style="max-height: 150px;    margin-top: 20px;"
                                                *ngFor="let product of ecomproducts">
                                                <div class="col-4" style="  max-height: 150px;">
                                                    <div class="img-wrapper" style="max-height: 150px;">
                                                        <div class="cart-info cart-wrap">


                                                            <a href="javascript:void(0)" title="Add to Wishlist"
                                                                (click)="saveFav(product)">
                                                                <i class="fa fa-heart" aria-hidden="true"
                                                                    [ngStyle]="product.fav ?{'color': 'red'} : {'color': 'white'}"></i>
                                                            </a>
                                                        </div>
                                                        <div class="lable-block">
                                                        </div>
                                                        <div class="front" style="max-height: 150px;">
                                                            <a
                                                                [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
                                                                <img style="max-height: 150px;"
                                                                    [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                                                                    [lazyLoad]="ImageSrc ? ImageSrc : product?.img"
                                                                    class="img-fluid lazy-loading"
                                                                    alt="{{ product?.img }}" />

                                                            </a>
                                                        </div>
                                                        <div class="back" *ngIf="onHowerChangeImage">
                                                            <a
                                                                [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
                                                                <img [src]="ImageSrc ? ImageSrc : product.img"
                                                                    class="img-fluid lazy-loading"
                                                                    alt="{{ product?.img }}">
                                                            </a>
                                                        </div>


                                                    </div>

                                                </div>
                                                <div class="col-8">
                                                    <div class="product-detail">
                                                        <div>

                                                            <a
                                                                [routerLink]="['/shop/product/left/sidebar/', product.pid, product.pname]">
                                                                <h3 style="margin: 0; font-size: 18px;">{{
                                                                    product?.pname | titlecase }}
                                                                </h3>
                                                            </a>


                                                            <bar-rating [rate]="product.avg_star"
                                                                [readOnly]="true"></bar-rating>
                                                            <h3 style="padding-bottom: 10px;font-size: larger;"
                                                                *ngFor="let data of product.preDef">
                                                                <strong class="kg" *ngIf="product?.cid > 0">{{data.qty}}
                                                                    -</strong> ₹ {{ data?.price}}
                                                            </h3>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 text-center section-b-space mt-5 no-found"
                                            *ngIf="ecomproducts.length == 0 && load == true">
                                            <img src="assets/images/empty-search.jpg" class="img-fluid mb-4">
                                            <h3>Sorry! Couldn't find the product you were looking For!!! </h3>
                                            <p>Please check if you have misspelt something or try searching with
                                                other words.</p>
                                            <a [routerLink]="['/shop/collection/left/sidebar?category=118']"
                                                class="btn btn-solid">continue shopping</a>
                                        </div>
                                    </div>


                                    <app-pagination [ecomproducts]="ecomproducts" [paginate]="paginate"
                                        (setPage)="setPage($event)">
                                    </app-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <app-skeleton-product-box *ngIf="loader"></app-skeleton-product-box> -->
</section>
<!-- section End -->